import { PERMISSIONS } from '@/generated/permissions'

export const invoiceRoutes = [
  {
    component: () =>
      import('@/domains/accounting/invoices/pages/IndexPage.vue'),
    meta: {
      anyPerm: [PERMISSIONS.INVOICE_READ, PERMISSIONS.INVOICE_UPDATE],
      requiresAuth: true,
      requiresQuickBooks: true,
    },
    name: 'invoices-index',
    path: '/invoices',
  },
  {
    component: () =>
      import('@/domains/accounting/invoices/pages/DetailPage.vue'),
    meta: {
      anyPerm: [PERMISSIONS.INVOICE_READ],
      requiresAuth: true,
      requiresQuickBooks: true,
    },
    name: 'invoices-detail',
    path: '/invoices/:id',
  },
]
